// extracted by mini-css-extract-plugin
export default {"additional_item":"fF","info_wrapper":"gF","addition_item_img_wrapper":"hF","title":"iF","quantity":"jF","flavors":"kF","old_price":"lF","discount":"mF","button_wrapper":"nF"};
    if(module.hot) {
      // 1715091679255
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  